import React, { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { observer, useLocalObservable } from "mobx-react"
import { Flex, Table } from "antd"
import { choose } from "choose-matching"

import { LoadingBlock } from "@src/app/components/LoadingBlock"
import { TransactionsTab } from "@src/pages/transactions"
import { TransactionsOutEmpty } from "@src/pages/transactionsOut/constants"
import { PaymentsCollection } from "@src/pages/transactionsPayments/classes/PaymentsCollection"
import { PaymentsOutColumns } from "@src/pages/transactionsPayments/constants"
import { PaymentsTableExpandable } from "@src/pages/transactionsPayments/PaymentsTableExpandable"
import { TableFilters } from "@src/shared/componemts/TableFilter"

export const TransactionsPaymentsPage = observer(() => {
  const payments = useLocalObservable(() => new PaymentsCollection())
  let [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const tab = searchParams.get("tab")
    const id = searchParams.get("id")

    if (tab === TransactionsTab.Payments && id) {
      payments.filter.onFormChange({ id })
    }
  }, [searchParams])

  return (
    <Flex gap={16} vertical>
      <TableFilters {...payments.filter.props} />
      {choose(
        [payments.isLoading && payments.isEmpty, <LoadingBlock />],
        [payments.isEmpty, <TransactionsOutEmpty />],
        [
          !payments.isEmpty,
          <Table
            columns={PaymentsOutColumns}
            dataSource={payments.items}
            expandable={{
              expandedRowRender: (record) => (
                <PaymentsTableExpandable
                  isLoading={payments.isLoading}
                  payment={record}
                />
              ),
            }}
            loading={payments.isLoading}
            pagination={payments.pagination}
            rowKey="id"
            scroll={{ x: true }}
            style={{ width: "100%" }}
          />,
        ],
      )}
    </Flex>
  )
})
